import { render, staticRenderFns } from "./assignment-line-edit-modal.vue?vue&type=template&id=20c2f9b0&scoped=true"
import script from "./assignment-line-edit-modal.vue?vue&type=script&lang=js"
export * from "./assignment-line-edit-modal.vue?vue&type=script&lang=js"
import style0 from "./assignment-line-edit-modal.vue?vue&type=style&index=0&id=20c2f9b0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20c2f9b0",
  null
  
)

export default component.exports